module.exports = __webpack_public_path__ + "static/media/YF42_0.afc5369b.jpg";